import { defineStore } from 'pinia';
import {
  login as userLogin,
  logout as userLogout,
  getUserInfo,
  getKookUserInfo,
  LoginData,
  KookLoginData,
  kookLogin,
} from '@/api/user';
import { setToken, clearToken, getToken } from '@/utils/auth';
import { UserState } from './types';

const roles = [
  'super',
  'admin',
  'service',
  'special_service',
  'treasurer',
  'user',
  'biggie',
];

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    union_id: undefined,
    user_id: undefined,
    discriminator: undefined,
    nickname: undefined,
    avatar: undefined,

    name: undefined,
    job: undefined,
    organization: undefined,
    location: undefined,
    email: undefined,
    introduction: undefined,
    personalWebsite: undefined,
    jobName: undefined,
    organizationName: undefined,
    locationName: undefined,
    phone: undefined,
    registrationDate: undefined,
    accountId: undefined,
    certification: undefined,
    role: undefined,
  }),

  getters: {
    userInfo(state: UserState): UserState {
      return { ...state };
    },
  },

  actions: {
    switchRoles(role) {
      return new Promise((resolve) => {
        // const index = roles.indexOf(this.role);
        this.role = role; // roles[(index + 1) % roles.length];
        // this.role = 'super'; // this.role === 'user' ? 'admin' : 'user';
        window.localStorage.setItem('userRole', this.role);
        resolve(this.role);
      });
    },
    // Set user's information
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
    },

    // Reset user's information
    resetInfo() {
      this.$reset();
    },

    // Get user's information
    async info() {
      // const res = await getUserInfo();
      const res = (await getKookUserInfo(getToken())) as any;
      const { userInfo } = res.data;
      this.setInfo(userInfo);
      console.log(this.role);
      // this.role = userInfo.role;
      // window.localStorage.setItem('userRole', userInfo.role);
    },

    // Login
    async login(loginForm: LoginData) {
      try {
        const res = await userLogin(loginForm);
        setToken(res.data.token);
      } catch (err) {
        clearToken();
        throw err;
      }
    },

    async kookLogin(loginParam: KookLoginData) {
      try {
        const res = await kookLogin(loginParam);
        if (res && res.data && res.data.result) {
          setToken(res.data.token);
          return true;
        }
      } catch (err) {
        clearToken();
        throw err;
      }
      return false;
    },

    // Logout
    async logout() {
      await userLogout();

      this.resetInfo();
      clearToken();
    },
  },
});

export default useUserStore;
